import type { ReactNode } from 'react'
import styles from './EtatVide.module.css'

interface ProprietesEtatVide {
  readonly titre: string
  /**
   * POURQUOI c'est vide, et quoi faire ensuite. « Aucun résultat » tout seul
   * s'interprète comme une panne — surtout après un filtre mal compris
   * (skill `frontend-react-afs` § Les trois états).
   */
  readonly explication: string
  readonly action?: ReactNode
}

export function EtatVide({ titre, explication, action }: ProprietesEtatVide): React.JSX.Element {
  return (
    <div className={styles.etat}>
      <span className={styles.titre}>{titre}</span>
      <p className={styles.explication}>{explication}</p>
      {action !== undefined && <div className={styles.action}>{action}</div>}
    </div>
  )
}
